import { GlButton, GlEmptyState, GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import emptyStateSvg from '@gitlab/svgs/dist/illustrations/status/status-new-sm.svg';
import { renderGFM } from '../../../../../../../app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';
import { destroyImageLightbox } from '../../../../../../../app/assets/javascripts/behaviors/markdown/render_image_lightbox.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import WorkplanAvailabilityPopover from './workplan_availability_popover.vue?vue3';
export default {
    name: 'WorkplanView',
    directives: {
        SafeHtml
    },
    components: {
        GlButton,
        GlEmptyState,
        GlLoadingIcon,
        WorkplanAvailabilityPopover
    },
    emptyStateSvg,
    props: {
        generationDisabledReason: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        canUpdate: {
            type: Boolean,
            required: true
        },
        savedContent: {
            type: String,
            required: true
        },
        savedContentHtml: {
            type: String,
            required: true
        },
        isFlowActive: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'start-edit',
        'generate'
    ],
    computed: {
        isRegenerating () {
            return this.isFlowActive && this.hasSavedContent;
        },
        hasSavedContent () {
            return Boolean(this.savedContent);
        }
    },
    watch: {
        savedContentHtml: {
            handler () {
                this.renderMarkdown();
            },
            immediate: true
        }
    },
    beforeDestroy () {
        if (this.$refs['gfm-content']) {
            destroyImageLightbox(this.$refs['gfm-content']);
        }
    },
    methods: {
        async renderMarkdown () {
            await this.$nextTick();
            renderGFM(this.$refs['gfm-content']);
        }
    }
};
